<mat-icon
  class="material-icons-outlined"
  style="font-size: {{ size }}px; max-width: {{ size }}px; color: {{ color }};"
  >{{ ICONS[icon] }}</mat-icon
>
